export const PARTNERS = [
    { value: "dw", name: "DW" },
    { value: "zanibal", name: "Zanibal" },
    { value: "infoware_ucml", name: "infoware" },
    { value: "sigma", name: "Sigma" },
    { value: "infoware_ucml", name: "Infoware" },
    { value: "ucml", name: "UCML" },
    { value: "alpaca", name: "Alpaca" },
    { value: "arm", name: "ARM" },    
    { value: "zanibal_ind", name: "Zanibal Ind" },
    { value: "kraken", name: "Kraken" },
    { value: "fireblocks", name: "Fireblocks" },
    { value: "fireblocks_kraken", name: "Fireblocks Kraken" },
    { value: "trove_fixed_return_ngn", name: "Fixed Return NGN" },
    { value: "trove_fixed_return_usd", name: "Fixed Return USD" },
    
]